// extracted by mini-css-extract-plugin
export default {"container":"index_container__aWfZ2","icon":"index_icon__rOyjc","content":"index_content__7Ey04","title":"index_title__-3JN1","address":"index_address__4u5AO"};